/* eslint-disable react/prop-types */
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { AvailableDate } from '../../../services/calendar/types/calenderTypes';

interface CalendarViewProps {
  dateRangeStatus: AvailableDate[];
  handleDayClick: (date: Date) => void;
  setActiveMonth: (date: Date) => void;
}

export const CalendarView: React.FC<CalendarViewProps> = ({
  dateRangeStatus,
  handleDayClick,
  setActiveMonth,
}) => {
  return (
    <div className="flex h-full flex-col items-center justify-center rounded-lg border border-gray-200 bg-gray-50 p-6 dark:border-neutral-700 dark:bg-neutral-900 md:w-3/5">
      <Calendar
        onChange={() => {}}
        value={new Date()}
        onClickDay={handleDayClick}
        onActiveStartDateChange={({ activeStartDate }) =>
          setActiveMonth(activeStartDate || new Date())
        }
        className="calendar-custom mx-auto w-full max-w-md"
        tileContent={({ date, view }) => {
          if (view !== 'month') {
            return null;
          }

          const today = new Date();
          const isToday =
            date.getFullYear() === today.getFullYear() &&
            date.getMonth() === today.getMonth() &&
            date.getDate() === today.getDate();

          // Only style dates present in dateRangeStatus (already filtered by statusViewFilter)
          const styledDate = dateRangeStatus.find(
            d =>
              d.date.getFullYear() === date.getFullYear() &&
              d.date.getMonth() === date.getMonth() &&
              d.date.getDate() === date.getDate()
          );

          if (!styledDate) {
            // For today's date, always render with proper text color
            if (isToday) {
              return (
                <div className="absolute inset-1 flex items-center justify-center rounded-md font-semibold text-gray-800 dark:text-white">
                  {date.getDate()}
                </div>
              );
            }
            return null; // Use default for non-today dates
          }

          // Existing logic for styled dates (available/busy)
          const baseClasses = styledDate.isAvailable
            ? 'bg-gradient-to-br from-pink-500 to-purple-600'
            : 'bg-neutral-600';

          const hoverClasses = styledDate.isAvailable
            ? 'hover:opacity-90'
            : 'hover:!bg-neutral-500';

          const ringClass = isToday ? 'ring-2 ring-white' : '';

          return (
            <div
              className={`absolute inset-1 flex items-center justify-center rounded-md font-semibold text-white ${baseClasses} ${hoverClasses} ${ringClass} transform-gpu transition-all duration-200 hover:scale-110`}
            >
              {date.getDate()}
            </div>
          );
        }}
      />

      {/* Legend */}
      <div className="mt-4 flex justify-center gap-6 text-sm">
        <div className="flex items-center gap-2">
          <div className="h-4 w-4 rounded-full bg-gradient-to-br from-pink-500 to-purple-600"></div>
          <span className="text-gray-600 dark:text-gray-300">Available</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="h-4 w-4 rounded-full bg-neutral-600"></div>
          <span className="text-gray-600 dark:text-gray-300">Busy</span>
        </div>
      </div>
    </div>
  );
};
